const quiz_component = {
  debug: true,
  debug_log: ['offline'],
  option: 0,
  init: ()=>{
      if (quiz_component.debug) {
          quiz_component.debug_log.push('quiz_component.init()');
          quiz_component.debug_log.push('quiz_component online');
          console.log(quiz_component.debug_log);
      }
      //establish bindings
      //immediately bind path location to page
      let local = window.location.href;
      $('[id$=\'BizForm_ncptextboxcontrol\'] input').attr('value', local);
      $('.js-back-container').hide();//only show on second slide
      $('input[id$=\'_BizForm_btnOK\']').clone().insertAfter('input[id$=\'_BizForm_btnOK\']').addClass('cloned').addClass('js-option-trigger');
      $('.js-option-trigger').show();

      let store = window.localStorage.getItem('dt-form');
      if(window.localStorage.getItem('dt-form') && window.localStorage.getItem('dt-result')){
        if (store.length || store != '' ) {
          console.log(store)
          // alert(store)

          // $('[data-id="'+ store +'"]')
          //go find where we left off
          $('.decision-tree > .row >ul.row').addClass('showing');
          $('.decision-tree > .row >ul.row > .option').hide();
          $('.decision-tree > .row > div h1 , .decision-tree > .row > div h3').hide();
          // $('[data-id="'+ store +'"]').parent().parent().find('.after-email').clone().insertAfter('.decision-tree')

          let product = window.localStorage.getItem('dt-result');
          let btnRow =  $('[data-id="'+ store +'"]').parent().parent().find('.after-email').find('[data-result-name="'+product+'"]');
          btnRow.closest('.result').addClass('final');
          let clone = btnRow.closest('.result').clone(true);
          // clone.insertAfter($('.decision-tree .row > .row.showing'))
          $('.decision-tree .row > .row.showing').append(clone);
          console.log(btnRow, product, 'store');
          window.localStorage.removeItem('dt-form');
          window.localStorage.removeItem('dt-result');
        }
      }

      // let formCheck = $('.InfoLabel').val();
      //   if (formCheck) {
      //   //go find where we left off
      //   $('.decision-tree > .row >ul.row').addClass('showing');
      //   // $('.decision-tree > .row >ul.row > .option').hide();
      //   $('.decision-tree > .row > div h1 , .decision-tree > .row > div h3').hide();
      //   $($('input[id$=\'BizForm_emailinput_txtEmailInput\']').parentsUntil('.email.form').parent()[0]).hide();
      //   $($('input[id$=\'BizForm_emailinput_txtEmailInput\']').parentsUntil('.email.form').parent()[0]).parent()
      //     .addClass('showing').parent().parent().addClass('showing').show().parent().show().find('img').first().hide().siblings('a').hide();
      //     $($('input[id$=\'BizForm_emailinput_txtEmailInput\']').parentsUntil('.email.form').parent()[0]).parent().show();
      //     // $($('input[id$=\'BizForm_emailinput_txtEmailInput\']').parentsUntil('.email.form').parent()[0]).hide();
      //     $($('input[id$=\'BizForm_emailinput_txtEmailInput\']').parentsUntil('.email.form').parent()[0]).parent().parent().find('.after-email').show().find('.row').first().css('display','inline-flex');
      //     $($("input[id$='BizForm_emailinput_txtEmailInput").parentsUntil('.email.form').parent()[0]).parent().parent().find('.after-email').css("display","inline-flex");
      //   }

      quiz_component.bindings();
  },
  bindings: ()=>{
      if (quiz_component.debug) {
          quiz_component.debug_log.push('quiz_component.bindings()');
          // console.log(quiz_component.debug_log, 'bindings');
      }
      $('.js-back-container').on('click', (e)=>{
        e.preventDefault();
        $('.decision-tree .next-clause').show();
        $('.decision-tree .option-selection').show();
        
        $('.final').removeClass('final');
        $('.option.answered').siblings().show();
        $('.option.answered').show();
        $('.option.answered').removeClass('answered');
        $('.option.answered .showing').removeClass('showing');
        $('.decision-tree.using').removeClass('using');
        $('.decision-tree .row.showing').removeClass('showing');
        $('.decision-tree > .row > div h1 , .decision-tree > .row > div h3').show();

        window.localStorage.removeItem('dt-result');
        
        // $('.js-back-container').hide();
        quiz_component.option = 0;
      });

      $('.js-reset').on('click',(e)=>{
        e.preventDefault()
        window.localStorage.removeItem('dt-result');
        window.localStorage.removeItem('dt-form');
        window.location = window.location.href.split('?')[0];
      });

      $('#form').off();

      $('.js-option-trigger').on('click', (e)=>{
        e.preventDefault();
        //validate, go to next slide, submit later?

        let formCheck = $('input[id$=\'BizForm_emailinput_txtEmailInput\']').val();
        if (formCheck.match(/@/)) {
          // console.log('check')
          //go find where we left off
          $('.decision-tree > .row >ul.row').addClass('showing');
          // $('.decision-tree > .row >ul.row > .option').hide();
          $('.decision-tree > .row > div h1 , .decision-tree > .row > div h3').hide();
          $($('input[id$=\'BizForm_emailinput_txtEmailInput\']').parentsUntil('.email.form').parent()[0]).hide();
          $($('input[id$=\'BizForm_emailinput_txtEmailInput\']').parentsUntil('.email.form').parent()[0]).parent()
            .addClass('showing').parent().parent().addClass('showing').show().parent().show().find('img').first().hide().siblings('a').hide();
          $($('input[id$=\'BizForm_emailinput_txtEmailInput\']').parentsUntil('.email.form').parent()[0]).parent().show();
          // $($('input[id$=\'BizForm_emailinput_txtEmailInput\']').parentsUntil('.email.form').parent()[0]).hide();
          if ($(window).outerWidth() < 1024) {

            $($('input[id$=\'BizForm_emailinput_txtEmailInput\']').parentsUntil('.email.form').parent()[0]).parent().parent().find('.after-email').show().find('.row').first().css('display','block');
            $($('input[id$=\'BizForm_emailinput_txtEmailInput\']').parentsUntil('.email.form').parent()[0]).parent().parent().find('.after-email').css('display','block');
          }else{

            $($('input[id$=\'BizForm_emailinput_txtEmailInput\']').parentsUntil('.email.form').parent()[0]).parent().parent().find('.after-email').show().find('.row').first().css('display','inline-flex');
            $($('input[id$=\'BizForm_emailinput_txtEmailInput\']').parentsUntil('.email.form').parent()[0]).parent().parent().find('.after-email').css('display','inline-flex');
          }
          if (history.pushState) {
            let parent = $(e.target).closest('.email.form').attr('data-id');
            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?form='+parent;
            window.history.pushState({path:newurl},'',newurl);
            window.localStorage.setItem('dt-form',  `${parent}`);
          }
          window.location.href = window.location.href + '#state';
        } else {
          // default error label: Please enter email value in format 'mymail@domain.com'.
          $('input[id$=\'BizForm_emailinput_txtEmailInput\'] ~ .form-control-error').text('Please enter email value in format \'mymail@domain.com\'.').addClass('EditingFormErrorLabel').show();
        }

        return false;
      })


      $('.option').on('click',(e)=>{
        if (($(e.target).hasClass('option') ||  $(e.target).parent().hasClass('option')) &&
          $(e.target).parent().find('.row.final').length > 0
        ) {

          //add this to form
          //validate, go to next slide, submit later?
          console.log($(e.target),'e target')

          if ($(e.target).closest('.row.final').length) {
            $('#SelectedProduct').find('input').val($(e.target).closest('.row.final').find('.btn-row').data('result-name'))
            window.localStorage.setItem('dt-result', $(e.target).closest('.row.final').find('.btn-row').data('result-name'))
            $('.js-back-container').hide();
            $('.decision-tree.using').addClass('done');
          } else {
            let string = $(e.target).parent().find('.row.final').find('.btn-row').data('result-name');
            window.localStorage.setItem('dt-result', $(e.target).parent().find('.row.final').find('.btn-row').data('result-name'))
            $('#SelectedProduct').find('input').val( string);
            $('.decision-tree.using').addClass('done');
          }
          if (window.localStorage.getItem('dt-result') && window.localStorage.getItem('dt-form')) {
            quiz_component.reloading = true;
            $('input[id$=\'_BizForm_btnOK\']:not(.js-option-trigger)').trigger('click')
          }
        }
        if (!quiz_component.reloading) {
          if (
            ($(e.target).hasClass('option') && !$(e.target).hasClass('answered')) 
            || ($(e.target).parent().hasClass('option') && !$(e.target).hasClass('answered'))
          ) {
            quiz_component.option = quiz_component.option + 1;
          }

          if (quiz_component.option === 1) {

            $('.js-back-container').show();
          }else{
            $('.js-back-container').hide();
          }

          if ($(e.target).hasClass('option') || $(e.target).hasClass('result')) {
            $(e.target).addClass('answered');
          }else{
            $(e.target).parent().addClass('answered');

          }
          if($('.final').length){
            $('.js-back-container').hide();
          }
          if (
            $(e.target).hasClass('option')
            && $(e.target).find('> ul > .result').length
          ) {
            $(e.target).find('ul').find('.result').parent().addClass('final');
            $('.option.answered > ul.showing > .answer .next-clause').hide();
            $('.option.answered > ul.showing > .answer .option-selection').hide();
          } else if(
            $(e.target).parent().hasClass('option') 
            && $(e.target).parent().find('> ul > .result').length
          ) {
            $(e.target).parent().find('ul').find('.result').parent().addClass('final');
            $('.option.answered > ul.showing > .answer .next-clause').hide();
            $('.option.answered > ul.showing > .answer .option-selection').hide();
          }


          $('.option.answered').siblings().hide();
          $('.option ul.showing').removeClass('showing');
          $('.option.answered > ul').addClass('showing');
          $('.option.answered > ul.showing > li > ul').addClass('showing');
          $('.decision-tree').addClass('using');

          if (quiz_component.debug) {
            quiz_component.debug_log.push('quiz_component.bindings(click option)');
            console.log(quiz_component.debug_log, 'clicked option');
            console.log('option:' , $(e.target));
          }
        }
      });

      $('input[id$=\'BizForm_emailinput_txtEmailInput\']').on('keydown', (evt) => {
        if (evt.keyCode == 13) {
          evt.preventDefault();
          $(evt.currentTarget).closest('.email.form').find('.js-option-trigger').trigger('click');
          return false;
        }
      })
  },
  answer_handler: (answer)=>{
      if (quiz_component.debug) {
          quiz_component.debug_log.push('quiz_component.answer_handler(answer)');
          console.log(quiz_component.debug_log, 'Handle points');
      }


  },
  reset: ()=>{
      if (quiz_component.debug) {
          quiz_component.debug_log.push('quiz_component.reset()');
          console.log(quiz_component.debug_log, 'restart/reset quiz');
      }
      quiz_component.init();
  }

}

$(document).ready(function () {

  if ($('.decision-tree').length) {
    quiz_component.init();
  }
});
